export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-en-8686f18e5caef835394f7b5fae06578c.webp";